import React from 'react'

export const planSvg = ({ color = '#999' }) => (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.46875 1.21875L1.96875 3.65625C1.375 3.875 1 4.4375 1 5.0625V12.0938C1 12.6562 1.3125 13.1875 1.8125 13.4375L8.3125 16.6875C8.75 16.9062 9.21875 16.9062 9.65625 16.6875L16.1562 13.4375C16.6562 13.1875 16.9688 12.6562 16.9688 12.0938V5.0625C16.9688 4.4375 16.5938 3.875 16 3.65625L9.5 1.21875C9.1875 1.09375 8.8125 1.09375 8.46875 1.21875ZM9 2.09375L16 4.71875L9 7.75L2 4.71875L9 2.09375ZM2 5.8125L8.5 8.625V15.6562L2 12.4062V5.8125ZM9.5 15.6562V8.625L16 5.8125V12.4062L9.5 15.6562Z"
            fill={color}
        />
        <path d="M9 2.79999L4 4.76426L9 6.90713L14 4.76426L9 2.79999Z" fill={color} />
    </svg>
)

export const sideSvg = ({ color = '#999' }) => (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 1.5C2 1.22386 1.77614 1 1.5 1V1C1.22386 1 1 1.22386 1 1.5V16C1 16.5523 1.44772 17 2 17H16.5C16.7761 17 17 16.7761 17 16.5V16.5C17 16.2239 16.7761 16 16.5 16H2.5C2.22386 16 2 15.7761 2 15.5V1.5Z"
            fill={color}
        />
        <path
            d="M6 3C6 8 6.5 13.5 14.5 13"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const tableSvg = ({ color = '#999' }) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 3H5V5H1V3Z" fill={color} />
        <path d="M17 3H7V5H17V3Z" fill={color} />
        <path d="M17 8H7V10H17V8Z" fill={color} />
        <path d="M7 13H17V15H7V13Z" fill={color} />
        <path d="M5 8H1V10H5V8Z" fill={color} />
        <path d="M1 13H5V15H1V13Z" fill={color} />
    </svg>
)
